// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__pBkWM","hidden":"Overlay_hidden__0v50Y"};